<template>
    <div class="sidebar">
        <el-menu
            class="sidebar-el-menu"
            :default-active="onRoutes"
            :collapse="true"
            background-color="#324157"
            text-color="#bfcbd9"
            active-text-color="#20a0ff"
            unique-opened
            router
        >
            <template v-for="item in items">
                <template v-if="item.children">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <!-- <el-tooltip class="item" effect="dark" :content="item.title" placement="right">
                            <i :class="item.icon" class="icon-warp"></i>
                        </el-tooltip> -->
                            <i :class="item.icon" class="icon-warp"></i>
							<span slot="title">{{ item.label }}</span>
                        </template>
                        <template v-for="subItem in item.children">
                            <el-submenu
                                v-if="subItem.children"
                                :index="subItem.index"
                                :key="subItem.index"
                            >
                                <template slot="title">{{ subItem.label }}</template>
                                <el-menu-item
                                    v-for="(threeItem,i) in subItem.children"
                                    :key="i"
                                    :index="threeItem.index"
                                >{{ threeItem.label }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item   
                                v-else
                                :index="subItem.index"
                                :key="subItem.index"
                            >{{ subItem.label }}</el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <el-tooltip class="item" effect="dark" :content="item.label" placement="right">
                            <i :class="item.icon" class="icon-warp"></i>
                        </el-tooltip>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import { fetchPost } from '../../../https';
import bus from '../common/bus';
export default {
    data() {
        return {
            collapse: true,
            items: []
        };
    },
    computed: {
        onRoutes(e) {
            return this.$route.path.replace('/', '');
        }
    },
    created() {
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', msg => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });
        this.items = JSON.parse(localStorage.getItem('currUserMenuFunction'));
    }
};
</script>

<style>
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom: 0;
    overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 80px;
}
.el-menu--collapse {
    width: 80px;
}
.sidebar > ul {
    height: 100%;
}
.icon-warp {
    font-size: 35px ;
    color: white !important;
}
.el-menu-item, .el-submenu__title{
    line-height: 75px;
    height: 75px;
    padding-left: 20px !important;
    text-align: center;
}
/* #app /deep/ .icon-warp {
    color: white;
} */
.el-menu--popup {
    min-width: 80px;
    padding: 0px !important;
}
/* 二级菜单样式修改 */
.el-menu--vertical .el-menu {
    background-color: #fff !important;
    color: #FFF !important;
    border-radius: 10px;
    z-index: 2000;
    font-size: 12px;
    left: -4px;
}
.el-menu--vertical .el-menu li:nth-child(1) {
    cursor: default;
    margin-bottom: 1px;
    border-radius: 2px;
    font-weight: bold;
}
.el-menu--vertical .el-menu-item {
    line-height: 35px;
    height: 35px;
    color: #fff !important;
}
</style>
